import { EmissionTypeEnum } from "../statck-info/stackInfo.entity";

export interface SubmitReportVocBody {
  userId: string;
  months: string[];
  year: string | number;
}

export interface GlobalRangeDateDto {
  startDate: string;
  endDate: string;
}

export interface KeyofMonthly {
  jan: any;
  feb: any;
  mar: any;
  apr: any;
  may: any;
  jun: any;
  jul: any;
  aug: any;
  sep: any;
  oct: any;
  nov: any;
  dec: any;
}

export const convertEmissionWord = (emission: string) => {
  if (emission === "TVOC") return "TVOCs";
  return emission;
};
